import { createStyles } from 'antd-style';

import { ThemeFont, ThemeSpaces } from '../theme';
import {
  absoluteMiddleToRight,
  heightExtendingError,
  spaceBetween,
} from '../styles/mixins';

export const useEditShipmentPageStyles = createStyles(({ token }) => ({
  editShipmentPageWrapper: {
    '&&': {
      ...heightExtendingError(token),
      maxWidth: 1024,
      margin: '0 auto',

      'h2.ant-typography': {
        fontFamily: ThemeFont.FONT_CONDENSED,
        marginBottom: 0,

        [`@media (min-width: ${token.screenLGMin}px)`]: {
          fontSize: ThemeFont.FONT_SIZE_HEADING_2_5,
        },
        [`@media (min-width: ${token.screenLGMin}px) and (max-width: ${token.screenMDMax}px)`]:
          {
            fontSize: ThemeFont.FONT_SIZE_HEADING_3_5,
          },
        [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
          {
            fontSize: token.fontSizeHeading4,
          },
        [`@media (max-width: ${token.screenSMMax}px)`]: {
          fontSize: token.fontSizeLG,
        },
      },
    },
  },

  topButtons: {
    display: 'flex',

    '> *': {
      ...spaceBetween(ThemeSpaces.SPACE_NORM_20),
    },

    '> .ant-btn:first-child': {
      width: 80,
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
    '> .ant-btn:last-child': {
      width: 200,
      fontSize: token.fontSize,
    },
  },

  editShipmentCancelShipment: {
    fontWeight: 700,
    color: token.colorPrimary,
    lineHeight: 1,

    [`@media (min-width: ${token.screenMDMin}px)`]: {
      fontSize: token.fontSize,
    },
    [`@media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenSMMax}px)`]:
      {
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      },
    [`@media (max-width: ${token.screenXSMax}px)`]: {
      fontSize: ThemeFont.FONT_SIZE_XS,
    },

    '> *': {
      textDecoration: 'underline',
    },

    'h2.ant-typography + &': {
      ...absoluteMiddleToRight(),
      right: -ThemeSpaces.SPACE_NORM_20,
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
  },
}));
